/**
 * BS_DT cart block A/B test (Amplitude flag bs_dt-cart-block, same deployment as bs_dt-pop-up).
 *
 *   control:   unchanged, no block in the cart drawer.
 *   treatment: the block from snippets/bsdt-cart-block.liquid, shown while the BS_DT criteria are unmet.
 *
 * Exposure follows the bs_dt-pop-up rule, moved from the checkout click to viewing the cart:
 * assets/dt-cart-popup.js calls window.villoidBsdtCartBlockVariant() whenever the cart drawer is on
 * screen (opened, or rebuilt while open) and the cart meets the popup's criteria. That call reads the
 * variant and logs the exposure; the SDK drops repeats on the same page. Exposure is sent explicitly:
 * the SDK caches one client per deployment key, and the first script to create it decides
 * automaticExposureTracking (both BS_DT tests pass false).
 *
 * Anything but a fetched 'treatment' is control: no SDK, no fetch yet, flag off or missing. The SDK
 * sends no exposure for a fallback variant, so those cart views stay out of the test.
 *
 * QA: ?bsdt_cart_block=treatment|control forces a variant (kept in localStorage, no exposure),
 * ?bsdt_cart_block=clear drops it.
 *
 * Cleanup: delete this file and its script tag in snippets/bsdt-cart-block.liquid. Treatment wins:
 * drop the villoidBsdtCartBlockVariant check in assets/dt-cart-popup.js. Control wins: delete
 * snippets/bsdt-cart-block.liquid, its render in snippets/cart-drawer.liquid, initCartBlock in
 * assets/dt-cart-popup.js and the bs_dt_cart_block_* theme settings.
 */
(function () {
  var FLAG_KEY = 'bs_dt-cart-block';
  var DEPLOYMENT_KEY = 'client-8fqJ5ArVAFM5z9c8R28C2hoCqKQyUMQe';
  var OVERRIDE_KEY = 'bsdt_cart_block_variant_override';
  var URL_PARAM = 'bsdt_cart_block';

  var client = null;

  function isVariant(v) {
    return v === 'control' || v === 'treatment';
  }

  function syncUrlOverride() {
    try {
      var v = new URLSearchParams(window.location.search).get(URL_PARAM);
      if (isVariant(v)) localStorage.setItem(OVERRIDE_KEY, v);
      if (v === 'clear') localStorage.removeItem(OVERRIDE_KEY);
    } catch (e) {}
  }

  function readOverride() {
    try {
      var v = localStorage.getItem(OVERRIDE_KEY);
      return isVariant(v) ? v : null;
    } catch (e) {
      return null;
    }
  }

  // window.Experiment comes from the Amplitude app embed, which boots after the window `load` event, so
  // the budget only counts once the page has loaded: a slow `load` must not starve the fetch.
  function waitForExperiment(callback) {
    var attempts = 0;
    (function check() {
      if (window.Experiment) return callback();
      if (document.readyState === 'complete' && ++attempts > 50) return;
      setTimeout(check, 200);
    })();
  }

  function initClient() {
    try {
      client = window.Experiment.initializeWithAmplitudeAnalytics(DEPLOYMENT_KEY, {
        serverZone: 'EU',
        automaticExposureTracking: false
      });
    } catch (e) {
      console.warn('[bsdt-cart-block-ab] Experiment init failed:', e);
      return;
    }
    client.fetch();
  }

  function fetchedVariant() {
    if (!client) return 'control';
    var result = client.variant(FLAG_KEY);
    try {
      client.exposure(FLAG_KEY);
    } catch (e) {}
    return result && result.value === 'treatment' ? 'treatment' : 'control';
  }

  syncUrlOverride();
  window.villoidBsdtCartBlockVariant = function () {
    return readOverride() || fetchedVariant();
  };
  waitForExperiment(initClient);
})();
